import { render, staticRenderFns } from "./vendorHeader.vue?vue&type=template&id=65001b2e&scoped=true"
import script from "./vendorHeader.vue?vue&type=script&lang=js"
export * from "./vendorHeader.vue?vue&type=script&lang=js"
import style0 from "./vendorHeader.vue?vue&type=style&index=0&id=65001b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65001b2e",
  null
  
)

export default component.exports